import dayjs from 'dayjs'
import type { SupplyManagementProvider } from './contexts/SupplyManagementContext'

export const endOfTime = dayjs('2999-12-31T23:59:59Z')

export type DateControlOptions = 'Now' | 'Specific'

export type DefaultFilters = {
  as_of: string
} & { [key: string]: string } // This type is used for any url query parameters

export type SupplyDirectoryQueryFilters = {
  groupBy: string
  priceLimit: number
  siteInfo?:
    | {
        siteOptionJSON: string
        onlyInNetworkTerminals: boolean
      }
    | undefined
  filter: DefaultFilters
}

export type ClientSideFilters = {
  includePlannedVolume: boolean
  dateControl: DateControlOptions
}

export type SupplyDirectoryHeaderFilters = SupplyDirectoryQueryFilters & ClientSideFilters

export type PriceManagementMetadata = {
  groupings: string[]
  stores: {
    number: string
    name: string
  }[]
  disabled_reasons: string[]
}

export type ISupplyManagementContext = ReturnType<typeof SupplyManagementProvider>
